import { useCallback, useState, useRef } from 'react';
import { getXlsxStatistic } from '../../../../data-layer/business/service';
import { BusinessStatisticParams } from '../../../../data-layer/business/types';
import { showNotificationAsync } from '../../../../data-layer/notifications/actions';
import { useDispatch } from '../../../../data-layer/useDispatch';
import { FeedManagementAdditionalField } from '../../../../ui/posts/FeedManagement/types';
import { downloadFile } from '../../../../utils/downloadFile';
import { makeFilters } from '../../FeedManagement/utils';

const getStatColumns = (additionalFields: Record<string, boolean>) =>
    [
        'shows_in_grid',
        additionalFields[FeedManagementAdditionalField.SHOWS] ? 'shows' : null,
        additionalFields[FeedManagementAdditionalField.COVERAGE] ? 'coverage' : null,
        additionalFields[FeedManagementAdditionalField.ACCOUNTS_INVOLVED] ? 'involved' : null,
        additionalFields[FeedManagementAdditionalField.SUBSCRIBERS] ? 'subscribers' : null,
        'interactions',
        additionalFields[FeedManagementAdditionalField.PROMOTION] ? 'boosting' : null,
    ].filter(Boolean) as string[];

export const useExportStatistic = (
    businessId: string,
    query: URLSearchParams,
    additionalFields: Record<FeedManagementAdditionalField, boolean>,
) => {
    const dispatch = useDispatch();
    const [isLoadingStatFile, setIsLoadingStatFile] = useState(false);
    const timer = useRef<number | undefined>();

    const onExportClick = useCallback(async () => {
        if (isLoadingStatFile) {
            return;
        }

        setIsLoadingStatFile(true);

        const params: BusinessStatisticParams = {
            ...(makeFilters(query) as BusinessStatisticParams),
            stat_columns: getStatColumns(additionalFields),
        };

        try {
            const result = await getXlsxStatistic(businessId, params);

            downloadFile(result.blob, result.filename);
        } catch (error) {
            dispatch(showNotificationAsync('Не удалось загрузить статистику'));

            return;
        } finally {
            clearTimeout(timer.current);

            timer.current = window.setTimeout(() => {
                setIsLoadingStatFile(false);
            }, 1000);
        }
    }, [businessId, query, additionalFields, dispatch, isLoadingStatFile]);

    return {
        isLoadingStatFile,
        onExportClick,
    };
};
